module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAAHlBMVEVHcEz////////////////////////////////////JATChAAAACnRSTlMAKMXilA3/GyElm3rdngAAAGpJREFUeNrt1kEKwCAMBVHjj1Hvf+FS3HTbKQhWZ/9QRInp9NMsS16AizvV1zAHlAooFVB6QFkylfUhG1hzL9mXkjZf8nvrCUphiLeKDwc6m+z6Iq4d9/0ROnR8zAk6Pso7cKM2viunPboA5gUJ9Ogbz7QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/right-arrows.png
// module id = OjtJ
// module chunks = 215